// Conversão de áudio gravado → MP3 (audio/mpeg, aceite pela Meta) no browser.
// formatarDuracao é puro (testável); blobToMp3 usa Web Audio (browser).
import { Mp3Encoder } from '@breezystack/lamejs';

export function formatarDuracao(segundos: number): string {
  const s = Math.max(0, Math.floor(segundos));
  const m = Math.floor(s / 60);
  const r = s % 60;
  return `${m}:${r.toString().padStart(2, '00')}`;
}

/** Decodifica o áudio gravado e codifica MP3 mono (128kbps). */
export async function blobToMp3(blob: Blob): Promise<Blob> {
  const arrayBuffer = await blob.arrayBuffer();
  const Ctx =
    window.AudioContext ||
    (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext;
  const ctx = new Ctx();
  try {
    const audioBuffer = await ctx.decodeAudioData(arrayBuffer);
    const sampleRate = audioBuffer.sampleRate;
    const canal = audioBuffer.getChannelData(0); // mono (canal 0)
    const samples = new Int16Array(canal.length);
    for (let i = 0; i < canal.length; i++) {
      const v = Math.max(-1, Math.min(1, canal[i]));
      samples[i] = v < 0 ? v * 0x8000 : v * 0x7fff;
    }
    const encoder = new Mp3Encoder(1, sampleRate, 128);
    const BLOCO = 1152;
    const partes: Int8Array[] = [];
    for (let i = 0; i < samples.length; i += BLOCO) {
      const mp3 = encoder.encodeBuffer(samples.subarray(i, i + BLOCO));
      if (mp3.length > 0) partes.push(mp3);
    }
    const fim = encoder.flush();
    if (fim.length > 0) partes.push(fim);
    return new Blob(partes, { type: 'audio/mpeg' });
  } finally {
    void ctx.close();
  }
}
